import { DrawerProps } from 'antd';
import React, { FC } from 'react';
import { FormattedMessage } from 'react-intl';
import styled from 'styled-components';
import { Button, SaveButton } from 'components/atoms/button';
import { Drawer as DrawerAtom } from 'components/atoms/drawer';

const Drawer = styled(DrawerAtom)`
  .ant-drawer-body {
    padding: var(--layout-02);
  }

  .ant-drawer-header {
    background: var(--coolest-gray-10);
  }
`;

interface FormDrawerProps extends DrawerProps {
  hideFooter?: boolean;
  isSubmitting?: boolean;
  isEdit: boolean;
  onOk: () => void;
  onCancel: (e: React.MouseEvent<HTMLElement>) => void;
  width: number;
}

export const IntervalDrawer: FC<FormDrawerProps> = ({
  hideFooter = false,
  isSubmitting,
  isEdit,
  onOk,
  onCancel,
  width,
  ...rest
}) => {
  return (
    <Drawer
      placement="right"
      width={width}
      footer={
        !hideFooter && (
          <>
            <Button data-cy="add-new-interval.cancel" onClick={onCancel}>
              <FormattedMessage id="cancel" />
            </Button>
            <SaveButton
              data-cy="add-new-interval.save"
              loading={isSubmitting}
              onClick={onOk}
            >
              <FormattedMessage id="save" />
            </SaveButton>
          </>
        )
      }
      {...rest}
    />
  );
};
